import { Component, Injectable, OnInit, TemplateRef } from '@angular/core';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';
import { CqQasService } from '../../../../../common/services/CqQas.service';
import { CqQuestionService } from '../../../../../common/services/CqQuestion.service';

import * as _ from 'lodash';

declare var $: any;

@Component({
  moduleId: module.id,
  selector: 'cq-question',
  templateUrl: './cq_question.component.html',
  styleUrls: ['./cq_question.css'],
  providers: [CqQasService, BsModalService, CqQuestionService],
})
@Injectable()
export class CqQuestionComponent implements OnInit {
  public dtOptions: any = {};
  public dtTrigger: Subject<any> = new Subject();

  public currentPage = 1;
  public totalRow = 0;
  public page_size = 10;
  public message: { class: string; content: string } = null;
  public list: any = [];
  public model: any = {};
  public typeModal: string;
  public modalRef: any = {};
  public modalRef2: any = {};
  public types: any = [];
  totalItem: any = 0;
  totalPage: any = 0;
  public modelFilter: any = {};

  public id_delete: number;
  public user: any = {};
  public data_options = [];
  public data_options_copy = [];
  public data_options_ans = [];
  public data_options_ans_copy = [];

  public answerValue: any = '';
  public answers: any = [];
  public allQna: any = [];

  constructor(
    private cq_question: CqQuestionService,
    private cq_qasService: CqQasService,
    private modalService: BsModalService,
    private toastr: ToastrService
  ) {
    this.user = JSON.parse(localStorage.getItem('User'));
  }

  ngOnInit() {
    this.loadData();
    this.getAllQna();
  }

  getAllQna() {
    this.cq_qasService
      .list()
      .toPromise()
      .then(
        res => {
          if (res.status == 200 && res.error == false) {
            console.log(res, 'asdasdasd');
            this.allQna = res.data.list.map(value => ({
              text: value.name,
              id: value._id,
            }));

            console.log(this.allQna);
          }
        },
        err => {
          this.message = {
            class: 'alert dark alert-danger',
            content: err.message,
          };
          this.list = [];
          // this.genDataTable();
          this.scrollToTop();
        }
      );
  }

  changeCategory(e: any): void {
    this.model.qas = e.value;
  }

  loadData(request: any = {}, sort: any = {}) {
    this.list = [];
    request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    request.limit = this.page_size;
    if (Object.keys(sort).length == 2) {
      request['sort_by'] = sort.field + ':' + sort.typeSort;
    }

    this.cq_question
      .list(request)
      .toPromise()
      .then(
        res => {
          if (res.status == 200 && res.error == false) {
            console.log(res, '----is res');
            this.list = res.data.list;
            this.totalItem = res.data.total;
            const pageString = (this.totalItem / this.page_size).toString();
            const pageSplit = pageString.split('.');
            let last: any;
            let totalpage = parseInt(pageSplit[0]);
            if (pageSplit.length > 1) {
              last = pageSplit[1];
              if (parseInt(last) > 0) {
                totalpage++;
              }
            }
            this.totalPage = totalpage;
          } else {
            this.message = {
              class: 'alert dark alert-danger',
              content: res.status + ' : ' + res.message,
            };
            this.list = [];
            // this.genDataTable();
            this.scrollToTop();
          }
        },
        err => {
          this.message = {
            class: 'alert dark alert-danger',
            content: err.message,
          };
          this.list = [];
          // this.genDataTable();
          this.scrollToTop();
        }
      );
  }

  search() {
    this.currentPage = 1;
    if (this.modelFilter.keyword && this.modelFilter.keyword.trim() != '') {
      this.loadData({ name: this.modelFilter.keyword });
    } else {
      this.loadData();
    }
  }

  scrollToTop() {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  }

  openModal(template: TemplateRef<any>, id?: any) {
    this.message = null;
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-lg',
      keyboard: false,
    };
    this.modalRef = this.modalService.show(template, config);

    this.model = {};
    this.typeModal = id ? 'edit' : 'add';

    console.log(this.typeModal);

    if (id) {
      this.cq_question
        .find(id)
        .toPromise()
        .then(rs => {
          console.log(rs);
          this.model = {
            qas: rs.data.qas.map(value => value._id),
            qas_id: rs.data._id,
            question: rs.data.name,
            answers: rs.data.answers.map(val => ({
              value: val,
              updating: false,
            })),
          };

          this.answers = this.model.answers;
          // this.data_options = rs.data.pattern;
          this.data_options_copy = Object.assign([], this.data_options);
        });
    } else {
      this.answers = [{ value: '', updating: true }];
      this.data_options = [];
      this.data_options_copy = [];
    }
  }

  add() {
    if (!this.model.qas || this.model.qas.lenght <= 0) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'QA không được bỏ trống !',
      };
      setTimeout(() => (this.message = null), 3000);
      return null;
    }
    if (!this.model.question) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Câu hỏi không được bỏ trống !',
      };
    } else {
      const data = [];
      let check = true;
      if (this.answers.length <= 0) {
        check = false;
        // for (var i = 0; i < this.data_options_copy.length; i++) {
        //     let check_ans = true;
        //     $('#opt-question' + i).css('border-color', '');
        //     if (!this.data_options[i].question || (this.data_options[i].question && this.data_options[i].question.trim() == '')) {
        //         $('#opt-question-' + i).css("border-color", 'red');
        //         check = false;
        //     } else {
        //         for (let j = 0; j < this.data_options_copy[i].data_options_ans_copy.length; j++) {
        //             let ans = this.data_options[i].data_options_ans[j];
        //             $('#opt-ans-' + i + '-' + j).css('border-color', '');
        //             if (!ans || (ans && ans.trim() == '')) {
        //                 $('#opt-ans-' + i + '-' + j).css('border-color', 'red');
        //                 check_ans = false;
        //             }
        //         }
        //         if (check_ans) {
        //             data.push(this.data_options[i]);
        //         } else {
        //             check = false;
        //         }
        //     }
        // }
      }

      this.answers.map(item => {
        if (item.updating) {
          check = false;
        }
      });
      if (!check) {
        this.message = {
          class: 'alert dark alert-danger',
          content: 'Câu trả lời không được bỏ trống !',
        };
        setTimeout(() => (this.message = null), 3000);
      } else {
        // this.model.data = _.map(data, e => {
        //     if(e.info && e.info.trim() != '') return e;
        // })
        for (let i = 0; i < data.length; i++) {
          delete data[i].data_options_ans_copy;
        }
        this.model.answers = this.answers.map(val => val.value);
        this.model.name = this.model.question;
        this.cq_question.create(this.model).subscribe(
          res => {
            if (res) {
              const error = res.error;
              if (error) {
                this.message = {
                  class: 'alert dark alert-danger',
                  content: 'Thêm mới không thành công',
                };
                this.toastr.error('Thêm mới thất bại', '', {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                });
              } else {
                this.message = {
                  class: 'alert dark alert-success',
                  content: 'Thêm mới thành công',
                };
                this.toastr.success('Thêm mới thành công', '', {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                });

                this.loadData();
                this.modalRef.hide();
              }
            }
          },
          error => {
            this.message = {
              class: 'alert dark alert-danger',
              content: error.message,
            };
          }
        );
      }
    }
  }

  edit(data) {
    this.message = null;
    let check = true;
    if (!this.model.qas || this.model.qas.lenght <= 0) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'QA không được bỏ trống !',
      };
      setTimeout(() => (this.message = null), 3000);
      return null;
    }
    if (!this.model.question) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Tên chủ đề không được bỏ trống !',
      };
    } else {
      const payload = {};
      if (this.model.question) {
        payload['name'] = this.model.question;
      }
      if (this.model.qas) {
        payload['qas'] = this.model.qas;
      }
      if (this.model.answers) {
        payload['answers'] = this.answers.map(val => val.value);
      }

      const data = [];
      if (this.answers.length <= 0) {
        check = false;
        // for (var i = 0; i < this.data_options_copy.length; i++) {
        //     let check_ans = true;
        //     $('#opt-question' + i).css('border-color', '');
        //     if (!this.data_options[i].question || (this.data_options[i].question && this.data_options[i].question.trim() == '')) {
        //         $('#opt-question-' + i).css("border-color", 'red');
        //         check = false;
        //     } else {
        //         for (let j = 0; j < this.data_options_copy[i].data_options_ans_copy.length; j++) {
        //             let ans = this.data_options_copy[i].data_options_ans_copy[j];
        //             $('#opt-ans-' + i + '-' + j).css('border-color', '');
        //             if (!ans || (ans && ans.trim() == '')) {
        //                 $('#opt-ans-' + i + '-' + j).css('border-color', 'red');
        //                 check_ans = false;
        //             }
        //         }
        //         if (check_ans) {
        //             data.push(this.data_options[i]);
        //         } else {
        //             check = false;
        //         }
        //     }
        // }
      }
      this.answers.map(val => {
        if (val.updating) {
          check = false;
        }
      });
      if (!check) {
        this.message = {
          class: 'alert dark alert-danger',
          content: 'Câu trả lời không được bỏ trống !',
        };
        setTimeout(() => (this.message = null), 3000);
      } else {
        for (let i = 0; i < data.length; i++) {
          delete data[i].data_options_ans_copy;
        }
        this.model.data = data;
        console.log(this.model.qas_id, payload);
        this.cq_question.update(this.model.qas_id, payload).subscribe(
          res => {
            if (res) {
              const error = res.error;
              if (error) {
                this.message = {
                  class: 'alert dark alert-danger',
                  content: 'Cập nhật không thành công',
                };
                this.toastr.error('Cập nhật thất bại', '', {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                });
              } else {
                this.message = {
                  class: 'alert dark alert-success',
                  content: 'Cập nhật thành công',
                };
                this.toastr.success('Cập nhật thành công', '', {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                });
                this.loadData();
                this.modalRef.hide();
              }
            }
          },
          error => {
            this.message = {
              class: 'alert dark alert-danger',
              content: error.message,
            };
          }
        );
      }
    }
    this.scrollToTop();
  }

  public changeType(e: any): void {
    this.model.type = e.value;
  }

  openConfirmDelete(template: TemplateRef<any>, id) {
    this.id_delete = id;
    // this.modalRef2 = this.modalService.show(template);
    const y = confirm('Bạn có muốn xóa không?');
    if (y) {
      this.submitDelete();
    }
  }

  submitDelete() {
    this.cq_question._delete(this.id_delete).subscribe(
      res => {
        if (res) {
          const error = res.error;
          if (error) {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Xóa không thành công',
            };
            this.toastr.error('Xóa không thành công', error.message, {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.message = {
              class: 'alert dark alert-success',
              content: 'Xóa thành công',
            };
            this.toastr.success('Xóa thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            this.loadData();
            // this.modalRef2.hide();
          }
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
        this.toastr.error('Xóa không thành công', error.message, {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        // this.modalRef2.hide();
      }
    );
  }

  setPage(page: number) {
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage) {
        this.currentPage = page;
        this.loadData();
      }
    } else {
      page = this.totalPage;
      $('#inputPage').val(page);
      this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      if (page <= this.totalPage) {
        // this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage) {
          this.currentPage = page;
          this.loadData();
        }
      }
    }
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  deleteOption(i) {
    this.data_options_copy.splice(i, 1);
    this.data_options.splice(i, 1);
  }

  addOption() {
    this.data_options_copy.push({
      question: '',
      data_options_ans_copy: [''],
      data_options_ans: [''],
    });
    this.data_options.push({
      question: '',
      data_options_ans_copy: [''],
      data_options_ans: [''],
    });
  }

  addOptionAns(i) {
    // this.data_options_copy[i].data_options_ans_copy.push("");
    // this.data_options_copy[i].data_options_ans.push("");
    // this.data_options[i].data_options_ans_copy.push("");
    // this.data_options[i].data_options_ans.push("");
    let checking = true;
    this.answers.map(val => {
      if (val.updating) {
        checking = false;
      }
    });
    if (checking) {
      this.answers.push({ value: '', updating: true });
      console.log(this.answers, 'this.answers');
    }
  }

  deleteOptionAns(i, j) {
    this.data_options_copy[i].data_options_ans_copy.splice(j, 1);
    this.data_options_copy[i].data_options_ans.splice(j, 1);
    this.data_options[i].data_options_ans_copy.splice(j, 1);
    this.data_options[i].data_options_ans.splice(j, 1);
  }

  saveScorecriteria(data, ind) {
    console.log(data, ind);
    if (this.answerValue) {
      this.answers.map((val, index) => {
        if (index == ind) {
          val.value = this.answerValue;
          val.updating = false;
        }
        console.log(val);
        return val;
      });

      this.answerValue = '';
    }
  }

  updateScorecriteria(data, ind) {
    this.answers.map((val, index) => {
      if (index == ind) {
        val.updating = true;
      }
      return val;
    });
    this.answerValue = this.answers.find((items, index) => index == ind).value;
  }

  delecriteria(data, ind) {
    console.log(data, ind, this.answers.length);
    if (this.answers.length >= 1) {
      this.answers = this.answers.filter((val, index) => ind !== index);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/cq_question/cq_question.component.ts